import React from "react"
import { Link } from "gatsby"
import 'bootstrap/dist/css/bootstrap.min.css'
import { Container, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faYoutube } from '@fortawesome/free-solid-svg-icons';
import '../styles/footer-styles.css'
import Crescat from '../images/crescat.svg'

export default function Footer({ children }) {

    return (
        <footer>
            <Container>
                <Row className="justify-content-center">
                    <Col xs={6} md={3}>
                        <p><strong>The University of Chicago</strong><br />
                            Career Advancement<br />
                            Ida Noyes Hall<br />
                            1212 E. 59th St<br />
                            Chicago, IL 60637 | P: 773-702-7040</p>
                        
                    </Col>
                    <Col xs={6} md={3}>
                        <p><strong>Hours</strong><br />
                            Monday — Friday<br />
                            8:30 a.m. to 5 p.m.<br />
                            (unless otherwise noted)</p>
                           
                        {/* <ul>
                            <li><a href="https://maps.uchicago.edu/" target="_blank" rel="noreferrer">Maps</a></li>
                            <li><a href="https://my.uchicago.edu/" target="_blank" rel="noreferrer">My.UChicago</a></li>
                            <li><a href="https://www.uchicago.edu/jobs/" target="_blank" rel="noreferrer">Job Opportunities</a></li>
                            <li><a href="https://titleixpolicy.uchicago.edu/" target="_blank" rel="noreferrer">Title IX</a></li>
                            <li><a href="https://www.uchicago.edu/about/non_discrimination_statement/" target="_blank" rel="noreferrer">Non-discrimination</a></li>
                            <li><a href="https://accessibility.uchicago.edu/" target="_blank" rel="noreferrer">Accessibility</a></li>
                        </ul> */}
                    </Col>
                    <Col xs={6} md={3}>
                        <ul>
                        <li><Link to="/privacy-notice/" >Privacy Notice</Link></li>
                            <li><Link to="/about/career-advancement-publications">View publications</Link></li>
                            <li><a href="https://accessibility.uchicago.edu/" target="_blank" rel="noreferrer">Accessibility</a></li>
                            <li><a href="//www.uchicago.edu/about/non_discrimination_statement/" target="_blank" rel="noreferrer">Non-Discrimination</a></li>
                            <li>&nbsp;</li>
                            <li><a href="https://www.youtube.com/@uchicagoadmissions" target="_blank">
                         <i class="fa-brands fa-youtube"></i>
                            </a>
                            <a href="https://www.instagram.com/uchicagocareers/" target="_blank">
                            <i class="fa-brands fa-square-instagram"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/career-advancement-the-university-of-chicago/" target="_blank">
                            <i class="fa-brands fa-linkedin"></i>
                            </a>
                            <a href="https://uchicago.joinhandshake.com/login" target="_blank">
                            <i class="fa-solid fa-square-h"></i>
                            </a>
                            
                            </li> 
                        </ul>
                    </Col>
                    
                    <Col className="crescat" xs={6} md={3}><img src={Crescat} alt="Crescate Scientia" loading="lazy" /></Col>
                    
                </Row></Container>
        </footer>
    )
}